import { CornerDownRight } from "lucide-react";
import type { ActionSpec } from "./RowActions";

/** Shared file/email row-action for toggling `isInsert`. */
export function insertToggleAction(opts: {
  fileId: string | undefined;
  isInsert: boolean;
  ineligibleIds: Set<string>;
  onToggle: (fileId: string, isInsert: boolean) => void;
  visible?: boolean;
}): ActionSpec {
  const blocked = !!opts.fileId && opts.ineligibleIds.has(opts.fileId) && !opts.isInsert;

  let label: string;
  if (opts.isInsert) {
    label = 'Revert to normal pagination';
  } else if (blocked) {
    label = "Can't be an insert — it's the first document, with no preceding page to anchor to";
  } else {
    label = 'Number these pages as decimals of the preceding page (e.g. 12.1, 12.2) without advancing the main count';
  }

  let className: string;
  if (opts.isInsert) {
    className = 'text-amber-600 hover:text-amber-700';
  } else if (blocked) {
    className = 'text-gray-300 cursor-not-allowed';
  } else {
    className = 'text-gray-400 hover:text-amber-600';
  }

  return {
    icon: CornerDownRight,
    label,
    onClick: () => {
      if (opts.fileId && !blocked) opts.onToggle(opts.fileId, !opts.isInsert);
    },
    visible: opts.visible,
    alwaysVisible: opts.isInsert,
    className,
  };
}
